import PropTypes from "prop-types";
import { Input, InputNumber } from "@/config/antd";

const ExpenseItem = ({ item, onChange }) => {
  return (
    <div className="p-4 border border-gray-300 rounded-md shadow-sm">
      {/* Item Name Input */}
      <Input
        placeholder="Enter item name"
        value={item.item}
        onChange={(e) => onChange({ ...item, item: e.target.value })}
        className="w-full text-base font-medium mb-4"
      />

      {/* Quantity, Unit Price, and Amount */}
      <div className="grid grid-cols-3 gap-4 items-center">
        {/* Quantity */}
        <InputNumber
          min={1}
          value={item.quantity}
          onChange={(value) => onChange({ ...item, quantity: value })}
          className="w-20 text-center rounded border-gray-300"
          controls
        />

        {/* Unit Price */}
        <InputNumber
          formatter={(value) => `${Number(value).toLocaleString()}`}
          parser={(value) => value.replace(/\D/g, "")}
          value={item.price}
          onChange={(value) => onChange({ ...item, price: value })}
          className="w-28 text-center rounded border-gray-300"
          controls
        />

        {/* Total Amount */}
        <div className="w-full text-center text-lightGrey font-normal text-bold">
          {(Number(item.quantity) * Number(item.price || 0)).toLocaleString()}
        </div>
      </div>
    </div>
  );
};

ExpenseItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    item: PropTypes.string,
    quantity: PropTypes.number,
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  onChange: PropTypes.func,
};

export default ExpenseItem;
